import React, { useState } from 'react';

/**
 * Logo component.
 *
 * <Logo />          — circular crown mark (nav, wherever a badge is needed)
 * <Logo full />     — full brand lockup image (footer)
 *
 * Falls back to a styled "M" mark if /logo.webp is missing.
 * Drop public/logo.webp to activate. public/logo.png also works as a legacy path.
 */
export default function Logo({ size = 44, full = false }) {
  const [err, setErr] = useState(false);

  if (full) {
    return (
      <span className="logo-full" aria-hidden="true">
        {!err ? (
          <img
            src="/logo.webp"
            alt=""
            className="logo-full-img"
            onError={() => setErr(true)}
          />
        ) : (
          /* Fallback: circular mark + text for footer */
          <span className="logo-full-fallback">
            <span className="logo-mark" style={{ width: 48, height: 48 }}>
              <span className="fallback">M</span>
            </span>
            <span className="logo-full-fallback-text">
              <span className="nav-brand-name">MALIK'S AROMA</span>
              <span className="nav-brand-sub">Luxury Oud · London</span>
            </span>
          </span>
        )}
      </span>
    );
  }

  /* Default: circular mark for nav */
  return (
    <span className="logo-mark" style={{ width: size, height: size }} aria-hidden="true">
      {!err ? (
        <img
          src="/logo.webp"
          alt=""
          className="logo-img"
          onError={() => setErr(true)}
        />
      ) : (
        <span className="fallback">M</span>
      )}
    </span>
  );
}
